import $ from 'jquery';

export default function formatCartItems(cartItems, cartUpsell) {
    if (cartUpsell && cartUpsell.length) {
        var upsellItem;

        cartItems.forEach(function(item) {
            if (!isSmartPak(item.ProductType)) {
                upsellItem = cartUpsell.filter(function(d) {
                    return d.ItemId === item.ItemId;
                })[0];

                $.extend(item, upsellItem);
            } else {
                item.SupplementViewModels.forEach(function(supplementItem) {
                    upsellItem = cartUpsell.filter(function(d) {
                        return d.ItemId === supplementItem.ItemId;
                    })[0];

                    $.extend(supplementItem, upsellItem);
                });

                item.IsAutoShipEligible = item.SupplementViewModels.some(function(supplement) {
                    return supplement.IsAutoShipEligible;
                });

                item.IsEligibleForAtsDiscount = item.SupplementViewModels.some(function(supplement) {
                    return supplement.IsEligibleForAtsDiscount;
                });

                item.IsEligibleForSmartPerks = item.SupplementViewModels.some(function(supplement) {
                    return supplement.IsEligibleForSmartPerks;
                });

                item.conditionalItemFullChargeSum = item.SupplementViewModels.reduce(function(sum, supplement) {
                    return sum + supplement.ConditionalItemFullCharge;
                }, 0);

                item.autoShipDiscountSum = item.SupplementViewModels.reduce(function(sum, supplement) {
                    var savings = supplement.AtsSaving ? supplement.AtsSaving : 0;
                    return sum + supplement.ConditionalItemFullCharge * (savings / 100);
                }, 0);

                item.hasAutoShipDiscount = item.autoShipDiscountSum > 0;

                item.autoShipDiscountPercent = Math.round(
                    (item.autoShipDiscountSum / item.conditionalItemFullChargeSum) * 100
                );

                delete item.ItemId;
            }
        });
    }

    return cartItems;
}

function isSmartPak(type) {
    return type === 1;
}


